import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor(private readonly http: HttpClient) { }

  exportImportFile(url) {
    return this.http.post(`${url}`, {}, { responseType: 'blob' });
  }

  getFileName(data) {
    return this.http.post(`${environment.api_url}export/catalog/file`, data);
  }

  downloadFile(data) {
    return this.http.post(`${environment.api_url}export/catalog/file`, data, { responseType: 'blob', observe: 'response' });
  }

  downloadFileProduct(data) {
    return this.http.post(`${environment.api_url}export/product`, data, { responseType: 'blob', observe: 'response' });
  }

  downloadFileProductTest() {
    return this.http.post(`${environment.api_url}export/test`, {}, { responseType: 'blob', observe: 'response' });
  }
}
